import Typewriter from 'typewriter-effect/dist/core';

export default function Typer(handle, {
    strings,
}) {
    const heading = handle.querySelector('h1');

    function doType() {
        const typewriter = new Typewriter(heading, {
            delay: 25,
        }); 

        strings.forEach((o, i) => {
            typewriter
                .deleteAll()
                .pauseFor(1500 * i)
                .typeString(o)
                .pauseFor(1500);
        });

        typewriter.start();
    }

    doType();
}
